
import { Options, Vue } from 'vue-class-component';
import { getReportVersion7 } from "@/api/index";
import ScoreNum from '../components/ScoreNum.vue';
import ReportSubTitleItem from '../components/ReportSubTitleItem.vue';
import ReportVersion7 from '@/views/share/components/ReportVersion7.vue';
import PersonInfoToast from '../components/PersonInfoToast.vue';
import Disclaimers from '../components/Disclaimers.vue';

@Options({
  components: {
    ScoreNum,
    ReportSubTitleItem,
    PersonInfoToast,
    Disclaimers,
    ReportVersion7,
  },
  data() {
    return {
      heartReportData: {},
      liverReportData: {},
      kidneyReportData: {},
      spleenReportData: {},
      avatarDefault: require('@/assets/img/icon/avatar.png'),
      loading: false,
    }
  },
  created() {
    document.title = '五藏测评报告'

    let tasks = [
      getReportVersion7(this.$route.params.reportId, 1).then((res: any) => {
        this.heartReportData = res
      }),
      getReportVersion7(this.$route.params.reportId, 2).then((res: any) => {
        this.liverReportData = res
      }),
      getReportVersion7(this.$route.params.reportId, 3).then((res: any) => {
        this.kidneyReportData = res
      }),
      getReportVersion7(this.$route.params.reportId, 5).then((res: any) => {
        this.spleenReportData = res
      }),
    ]

    Promise.allSettled(tasks).finally(()=>{
      this.loading = false;
    })

  },
  methods: {
    onRefresh  ()  {
      location.reload();
    },
  },
})
export default class ExpertReport extends Vue {}
